import { Locale } from './types';

export const LOCALE_STORAGE_KEY = 'brick-my-name-lang';

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'en' || value === 'es';
}

export function getInitialLocale(): Locale {
  if (typeof window === 'undefined') return 'en';

  const { pathname, search } = window.location;

  if (pathname === '/es.html' || pathname.endsWith('/es.html')) {
    return 'es';
  }

  const langParam = new URLSearchParams(search).get('lang');
  if (isLocale(langParam)) return langParam;

  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (isLocale(stored)) return stored;
  } catch {
    // localStorage may be unavailable
  }

  if (navigator.language.toLowerCase().startsWith('es')) {
    return 'es';
  }

  return 'en';
}

export function getHomePath(locale: Locale): string {
  return locale === 'es' ? '/es.html' : '/';
}

export function getGuidePath(locale: Locale): string {
  return locale === 'es' ? '/guia-nombre-lego.html' : '/lego-name-guide.html';
}

export function getVolumeLettersPath(locale: Locale): string {
  return locale === 'es' ? '/letras-volumen.html' : '/volume-letters.html';
}

export function getPopularNamesPath(locale: Locale): string {
  return locale === 'es' ? '/nombres-lego-populares.html' : '/popular-lego-names.html';
}

export function applyDocumentLocale(locale: Locale): void {
  document.documentElement.lang = locale;
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // ignore
  }
  const root = document.getElementById('root');
  if (root) {
    root.setAttribute(
      'aria-label',
      locale === 'es' ? 'Generador de nombre en bloques LEGO' : 'LEGO name generator',
    );
  }
}
